import { useState } from 'react';

import { DUTIES_MAX_LENGTH, useMyDuties, useSaveMyDuties } from '@/pages/mypage/useMyDuties';

/**
 * 내 담당업무 (V437 · 사용자 지시 2026-10-08). 직원찾기의 「업무로 찾기」 가 이 글에서 찾는다.
 *
 * <p>고치면 <b>바로 반영된다</b>(사용자 결정 2026-10-08) — 인사 담당의 승인을 거치지 않는다. 인사자료의
 * 같은 칸과 한 칸이라, 인사 담당이 고친 글도 여기 그대로 보인다.
 *
 * <p>따로 선 줄이 아니라 <b>인사 정보 표의 맨 아래 한 줄</b>이다(사용자 지시 2026-11-02 · `.my-info .wide`).
 * [수정] 을 누르면 그 칸이 그 자리에서 입력칸이 된다.
 *
 * <p>인사 정보가 이어지지 않은 계정은 고칠 자리가 없다 — 그 사유는 저장을 눌렀을 때 서버가 답한다.
 */
export function MyDutiesRow() {
  const mine = useMyDuties();
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const save = useSaveMyDuties(() => setEditing(false));

  const current = mine.data?.duties ?? '';
  const button = { fontSize: '12px', padding: '3px 10px' } as const;

  return (
    <div className="wide">
      <dt>담당업무</dt>
      <dd>
        {editing ? (
          <textarea
            className="input-field"
            aria-label="담당업무"
            rows={3}
            maxLength={DUTIES_MAX_LENGTH}
            value={draft}
            onChange={(event) => setDraft(event.target.value)}
            style={{ width: '100%', fontSize: '13px', fontWeight: 400, lineHeight: 1.6, fontFamily: 'inherit', resize: 'vertical' }}
            autoFocus
          />
        ) : (
          <span style={{ whiteSpace: 'pre-wrap' }}>{current || '-'}</span>
        )}
        {editing && save.isError && (
          <span style={{ display: 'block', fontSize: '12px', fontWeight: 400, color: 'var(--danger)', marginTop: '4px' }}>
            {save.error.message}
          </span>
        )}
      </dd>
      <span className="my-info-action">
        {editing ? (
          <span className="flex gap-1">
            <button className="btn-secondary" style={button} onClick={() => setEditing(false)}>취소</button>
            <button className="btn-primary" style={button} disabled={save.isPending} onClick={() => save.mutate(draft)}>
              {save.isPending ? '저장 중' : '저장'}
            </button>
          </span>
        ) : (
          <button
            className="btn-secondary"
            style={button}
            onClick={() => {
              setDraft(current);
              save.reset();
              setEditing(true);
            }}
          >
            수정
          </button>
        )}
      </span>
    </div>
  );
}
